import I18n from 'i18n-js';
import en from './languages/en';
import th from './languages/th';
I18n.locale = 'th';
I18n.fallbacks = true;
I18n.translations = { en, th };
